import { Box, makeStyles } from '@material-ui/core';
import { Table } from 'antd';
import clsx from 'clsx';
import React from 'react';
import EmptyTable from '../guesser/report/emptyTable';

const useStyles = makeStyles(theme => ({
  bordered: {
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: '0px 16px',
    background: 'white',
  },
}));

const AntTable = ({
  border = true, className, pagination, wrapperProps, ...otherProps
}) => {
  const classes = useStyles();

  return (
    <Box
      {...wrapperProps}
      className={clsx(
        {
          [classes.bordered]: border,
        },
        wrapperProps?.className,
      )}
    >
      <Table
        pagination={pagination === false ? false : {
          simple: true,
          ...pagination,
        }}
        className={clsx('bo-table', className)}
        locale={{
          emptyText: <EmptyTable pb={8} />,
        }}
        {...otherProps}
      />
    </Box>
  );
};

export default AntTable;
